import React from 'react';
// import styles from './subscribe.module.scss';

const Subscribe = () => {
    return (
        <div>
            {/* <div className={`${styles.section}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className={styles.content}>
                                <h3 className={styles.title}>
                                    <div>Discover the best tennis in your area</div>
                                </h3>
                                <p className={styles.description}>
                                    Sign up to receive our weekly newsletter and stay up-to-date with the community.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className={`${styles.content} form-inline jcc`}>
                                <input className={`form-control form-control-xl mb16 ${styles.input}`} placeholder={`Enter your email address`}/>
                                <button className={`btn btn-xl btn-default mb16 ${styles.subscribeBtn}`}>SUBSCRIBE</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default Subscribe;
